import React, { Component } from 'react';
import Powerbi from '../components/Powerbi';
import { Helmet } from 'react-helmet';
import * as pbi from 'powerbi-client';
import { connect } from 'react-redux';
import { requestProviderScorecardReport } from "../../../store/power-bi/PowerBiActions";
import { hostTitle } from '../../../config/ui';

class ProviderScorecardReport extends Component {
  componentWillMount() {
    this.props.getProviderScorecardReport();
  };

  render() {
    const models = pbi.models;
    const data = this.props.reports.providerScorecard;

    return (
      <div id="reportContainer">
        <Helmet title={`Provider Scorecard – ${hostTitle()}`} />
        {data.accessToken &&
          <Powerbi
            id={data.id}
            embedUrl={data.embedUrl}
            accessToken={data.accessToken}
            tokenType={models.TokenType.Embed}
            filterPaneEnabled={true}
            navContentPaneEnabled={true}
            width='100%'
            height='600px'
          />
        }
      </div>
    )
  }
}

export default connect(
  state => state.powerbi,
  dispatch => ({
    getProviderScorecardReport: () => dispatch(requestProviderScorecardReport()),
  }),
)(ProviderScorecardReport);



// WEBPACK FOOTER //
// ./src/routes/reports-analytics/containers/ProviderScorecardReport.js